export enum AuthenticationMethodState {
	Uninitialized,
	CanLogin,
	CannotLogin,
	LoggingIn,
}

export default interface IAuthenticationMethod {
	readonly currentState: AuthenticationMethodState
	readonly isLoggingIn: boolean
	readonly canLogin: boolean
}
